<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">
        </div>

        <div class="contenido_">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-2">
                        <h3>
                            Configuración
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-2">
                        <!-- <label for="" class="form-label">Acción</label> -->
                        <select class="form-control form-control-sm" v-model="tipo_configuracion">
                            <option value="">Seleccionar</option>
                            <option value="usuarios">Usuarios</option>
                        </select>
                    </div>
                </b-row>

                <ListaUsuarios v-if="tipo_configuracion == 'usuarios'" />

            </b-container>
        </div>
    </div>
</template>

<script>
    import ListaUsuarios from './Usuarios/Lista.vue'

    export default {
        name: 'MenuConfiguracion',
        components: {
            ListaUsuarios,
        },
        data() {
            return {
                tipo_configuracion: 'usuarios',
            }
        },
        methods: {

        },
    }
</script>

<style></style>